import { memo } from "react";

import Stack from "@mui/material/Stack";

import { Finding } from "stores/FindingStore";

import DataListItem from "components/DataListItem";

// -----------------------------------------------------------------------------

const BoxFindingDetailsErrantShare = memo(
  function BoxFindingDetailsErrantShare({
    finding,
  }: BoxFindingDetailsErrantShareProps) {
    const details = finding?.details as unknown as BoxDetails;

    //
    return (
      <Stack spacing={1} width="100%">
        <DataListItem label="Filename">{details?.asset?.name}</DataListItem>
        <DataListItem label="Destination folder name">
          {details?.asset?.details?.destination_folder?.name}
        </DataListItem>
        <DataListItem label="Responsible email">
          {details?.actor?.email}
        </DataListItem>
      </Stack>
    );
  }
);

export default BoxFindingDetailsErrantShare;

// -----------------------------------------------------------------------------

interface BoxFindingDetailsErrantShareProps {
  finding: Finding;
}

interface BoxDetails {
  actor: {
    email: string;
  };
  asset: {
    name: string;
    details: {
      destination_folder: {
        name: string;
      };
    };
  };
}
